module.exports = __webpack_public_path__ + "media/images/creator/story_count_achievement_mailer/ogp_image_20-756397296ee31731cd9191a4e9479c50.png";